{
  "appName": "Submit Medical Expenses To Support A Pension or D.I.C. Claim",
  "entryFile": "./medical-expense-report-entry.jsx",
  "entryName": "medical-expense-report",
  "rootUrl": "/supporting-forms-for-claims/submit-medical-expense-report-form-21p-8416",
  "productId": "66940f08-4d8d-486c-8dc2-605ddeb9247e",
  "datadog": {
    "applicationId": "942123ec-ea99-4820-b5e1-81283526f070",
    "clientToken": "pubf8718ac9a1e8b627ae98dda7f30516e2",
    "service": "benefits-medical-expense-report",
    "toggleName": "medicalExpenseReportsBrowserMonitoringEnabled",
    "sessionReplaySampleRate": 20
  }
}
